import React from "react";
import Frontend from "./Frontend";
import Backend from "./Backend";
import "./skills.scss";
import Others from "./Others";

const Skills = () => {
  return (
    <section className="skills section" id="skills">
      <h2 className="section_title">Skills</h2>
      <span className="section_subtitle">My technical level</span>

      <div className="skills_container container grid">
        <Frontend />
        <Backend />
        <Others />
      </div>
    </section>
  );
};

export default Skills;
